"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BannerSASLogo = {
    name: 'BannerSASLogo',
    suppressMirroring: true,
    tooltipKey: 'BannerSASLogo.icon.label',
    render: function (props, svgRef) {
        return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: ['BannerSASLogo', props.className].join(' '), width: "14", height: "14", x: "0", y: "0", version: "1.1", viewBox: "0 0 14 14", xmlSpace: "preserve", ref: svgRef }, props),
            props.tooltip && react_1.default.createElement("title", null, props.tooltip),
            react_1.default.createElement("path", { className: "svgToolTipPane", fill: "none", d: "M0 0h14v14H0z" }),
            react_1.default.createElement("path", { className: "bannerIconColor", d: "M9.687 6.379c2.749 3.336.235 6.227-2.014 6.79-2.594.649-4.94-.701-5.64-2.764.902 1.47 3.522 1.789 4.948.893 1.619-1.017 2.153-2.803.959-4.251L6.175 4.923c-.31-.375-.199-.888.177-1.197.373-.308.88-.31 1.191.06l2.144 2.593zm-4.838 2.56l-.007.006.464.561c.311.37.817.367 1.191.059.376-.31.486-.822.177-1.198l-.187-.226.004-.004-1.54-1.852c-1.193-1.447-.66-3.233.959-4.25 1.426-.896 4.046-.578 4.948.894C10.159.865 7.812-.484 5.218.164 2.968.726.454 3.617 3.204 6.954l1.645 1.985zm6.778 1.313l.144.227h-.086l-.134-.223h-.088v.223h-.076v-.514h.192c.12 0 .18.045.18.146 0 .092-.057.132-.132.141zm-.072-.062c.066 0 .123-.006.123-.084 0-.064-.057-.075-.11-.075h-.105v.159h.092zm.445.031a.441.441 0 01-.443.445.441.441 0 01-.446-.445c0-.256.205-.444.446-.444a.44.44 0 01.443.444zm-.089 0a.357.357 0 00-.355-.37.357.357 0 00-.357.37c0 .214.156.372.357.372.198 0 .355-.158.355-.372z" })));
    },
};
exports.default = BannerSASLogo;
